import { addOrDeleteWishlist } from '../utils/wishlist';
import { handleLoginCreate } from '../utils/signInOutUp/AuthenticationHelper';
import { trackLoginStart } from '../hooks/useLoginTracking/useLoginTracking';

function toggleTooltip({ tooltip, visible }) {
  if (!tooltip) return;
  tooltip.attr('aria-hidden', visible ? 'false' : 'true');
}

export function initWishlist() {
  $(function () {
    // Full wishlist notification
    if (window.theme.wishlist.isFull()) {
      $('.wishlist__notification').hide();
      $('div.wishlist-top-bar').before(`
				<div class="wishlist__notification">
				<svg class="wishlist__notification-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Zm.9,13.5H8.1V11.7H9.9Zm0-3.6H8.1V4.5H9.9Z"/></svg>
					<p class="wishlist__notification-text">
					Your wishlist has reached capacity. To continue adding to your list, please remove some products from your wishlist.
					</p>
				</div>
			`);
    }

    // Clear all button functionality
    const $clearWishlistButton = $('#wishlist-clear-all-button');
    $clearWishlistButton.unbind('click');
    $clearWishlistButton.click(event => {
      event.stopPropagation();
      event.preventDefault();

      const $tooltip = $clearWishlistButton.parent().find(`span.wishlist-remove-all-tool-tip`).first();

      if ($tooltip.attr('aria-hidden') === 'false') {
        toggleTooltip({ tooltip: $tooltip, visible: false });
        return;
      }

      toggleTooltip({ tooltip: $tooltip, visible: true });

      $tooltip.html('<p class="clear-text">Are you sure you want<br/> to clear your list?</p>');
      $tooltip.append('<button class="cancel">Cancel</button>');
      $tooltip.append('<button class="clear">Clear List</button>');

      // Tooltip Cancel button
      $tooltip.find('button.cancel').click(event => {
        event.stopPropagation();
        event.preventDefault();

        toggleTooltip({ tooltip: $tooltip, visible: false });
      });

      // Tooltip mouseleave
      $tooltip.mouseleave(() => {
        toggleTooltip({ tooltip: $tooltip, visible: false });
      });

      // Tooltip Clear button
      $tooltip.find('button.clear').click(async event => {
        event.stopPropagation();
        event.preventDefault();

        toggleTooltip({ tooltip: $tooltip, visible: false });

        $('.wishlist__notification').hide();
        await addOrDeleteWishlist('clearAllItem', '9999', '9999');

        window.dataLayer.push({
          event: 'sendEvent',
          eventCategory: 'Account',
          eventAction: 'wishlist',
          eventLabel: 'clear',
        });

        $('.wishlist-top-bar').remove();
        $('.wishlist-bottom-bar').remove();
        $('#wishlist-container').html(`
						<div class="wishlist__notification">
							<p class="wishlist__notification-text">
								Your wishlist is empty. Start browsing the website and add some products to your wishlist.
							</p>
						</div>
					`);
      });
    });
  });

  // Theme wishlist object
  window.theme.wishlist = {
    add: async (currentTarget, sku, variantId, gtmData) => {
      const $button = $(document).find(currentTarget);
      const dataAttr = $button.data('product-objectid')
        ? `[data-product-objectid="${sku}"]`
        : `[data-product-sku="${sku}"]`;
      const $tooltip = $button.parent().find(`span.tool-tip${dataAttr}`);

      const gtmProducts = window.gtm.searchProducts ? window.gtm.searchProducts : window.gtm.products || [];

      // Closes tooltip if clicking on button when tooltip is open
      if ($tooltip.attr('aria-hidden') === 'false') {
        toggleTooltip({ tooltip: $tooltip, visible: false });
        $button.attr('data-state', 'toAdd');
        return;
      }

      // add to wishlist
      // eslint-disable-next-line no-negated-condition
      if (
        window.theme.isCustomerLoggedIn ||
        (window.Jbhifi?.customerDetails && window.Jbhifi.customerDetails.isLoggedIn)
      ) {
        $(`${currentTarget.localName}${dataAttr}`).find('span.to-add').css('display', 'none');
        $(`${currentTarget.localName}${dataAttr}`).find('span.to-remove').css('display', 'flex');

        // setup State
        $(`${currentTarget.localName}${dataAttr}`).attr('data-state', 'toRemove');

        // setup Added tooltip
        const $tooltip = $button.parent().find(`span.tool-tip${dataAttr}`);

        if ($tooltip) {
          $tooltip.html('Added');
        }

        if (gtmData?.id) {
          window.dataLayer.push({
            event: 'wishlist',
            action: 'add',
            pageType: window.gtm.pageType,
            ecommerce: {
              products: [gtmData],
            },
          });
        } else {
          gtmProducts.forEach(product => {
            if (Number(product.id) === sku) {
              window.dataLayer.push({
                event: 'wishlist',
                action: 'add',
                pageType: window.gtm.pageType,
                ecommerce: {
                  products: [product],
                },
              });
            }
          });
        }

        // add
        await addOrDeleteWishlist('addItem', sku, variantId).then(() => {
          window.Jbhifi.wishlistItems = {
            ...window.Jbhifi.wishlistItems,
            [sku]: { variantId: variantId, dateAdded: new Date().toISOString().replace('T', ' ').slice(0, -5) },
          };
        });
      } else {
        // push attempt to GTM
        if (gtmData?.id) {
          window.dataLayer.push({
            event: 'wishlist',
            action: 'attempt',
            pageType: window.gtm.pageType,
            ecommerce: {
              products: [gtmData],
            },
          });
        } else {
          gtmProducts.forEach(product => {
            if (Number(product.id) === sku) {
              window.dataLayer.push({
                event: 'wishlist',
                action: 'attempt',
                pageType: window.gtm.pageType,
                ecommerce: {
                  products: [product],
                },
              });
            }
          });
        }

        // Login popup for wishlist
        toggleTooltip({ tooltip: $tooltip, visible: true });
        $button.attr('data-state', 'login');

        $tooltip.html('<p class="login-text">You\'re one step away from having this in your wishlist!</p>');
        $tooltip.append('<button class="login">Log in</button>');
        $tooltip.append('<button class="create-account">Create account</button>');
        $tooltip.append(
          `<svg class="close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.31 13.31"><path d="M11.6 13L6.65 8.04 1.7 13a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.38l4.95-4.95L.28 1.7C-.112 1.318-.112.682.28.3S1.308-.102 1.7.3l4.95 4.95L11.6.3a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.39L8.06 6.63 13 11.6a1 1 0 0 1-.71 1.706 1 1 0 0 1-.71-.296z" fill="#010101"/></svg>`
        );

        $tooltip.find('svg.close').click(() => {
          toggleTooltip({ tooltip: $tooltip, visible: false });
          $button.attr('data-state', 'toAdd');

          window.dataLayer.push({
            event: 'sendEvent',
            eventCategory: 'Account',
            eventAction: 'Close pop up',
            eventLabel: 'wishlist',
          });
        });

        const loginEventData = {
          eventCategory: 'my account',
          group: 'wishlist',
        };

        const loginReturnUrl = `/account/login?returnUrl=${encodeURIComponent(
          location.href
        )}&wishlistItem=${encodeURIComponent(`${sku}:${variantId}`)}`;

        $tooltip.find('button.login').click(event => {
          event.stopPropagation();
          event.preventDefault();
          trackLoginStart({ baseEventData: loginEventData });
          handleLoginCreate(loginReturnUrl);
        });

        $tooltip.find('button.create-account').click(event => {
          event.stopPropagation();
          event.preventDefault();
          trackLoginStart({ baseEventData: loginEventData, isCreate: true });

          handleLoginCreate(loginReturnUrl, { userJourneyMode: 'LOCAL_ACCOUNT_REGISTRATION' });
        });
      }
    },
    addDirect: (sku, variantId) => {
      return addOrDeleteWishlist('addItem', sku, variantId).then(() => {
        window.Jbhifi.wishlistItems = {
          ...window.Jbhifi.wishlistItems,
          [sku]: { variantId: variantId, dateAdded: new Date().toISOString().replace('T', ' ').slice(0, -5) },
        };
      });
    },
    remove: async (currentTarget, sku, variantId, gtmData) => {
      const $targetButton = $(document).find(currentTarget);
      const dataAttr = $targetButton.data('product-objectid')
        ? `[data-product-objectid="${sku}"]`
        : `[data-product-sku="${sku}"]`;
      const $button = $(document).find(`${currentTarget.localName}${dataAttr}`);
      const $wishlistContainer = $targetButton.parents('div[id^=wishlist-item-]');
      const isWishlistPage = $wishlistContainer.length > 0;
      const gtmProducts = window.gtm.searchProducts ? window.gtm.searchProducts : window.gtm.products;

      // remove from wishlist
      if (
        window.theme.isCustomerLoggedIn ||
        (window.Jbhifi?.customerDetails && window.Jbhifi.customerDetails.isLoggedIn)
      ) {
        $button.find('span.to-add').css('display', 'flex');
        $button.find('span.to-remove').css('display', 'none');
        $button.attr('data-state', 'toAdd');

        const $tooltip = $button.parent().find(`span.tool-tip${dataAttr}`);

        if ($tooltip) {
          toggleTooltip({ tooltip: $tooltip, visible: true });
          $tooltip.html('Removed');
        }

        isWishlistPage ? $wishlistContainer.remove() : null;

        // push attempt to GTM
        if (gtmData?.id || gtmData?.Id) {
          window.dataLayer.push({
            event: 'wishlist',
            action: 'remove',
            pageType: window.gtm.pageType,
            ecommerce: {
              products: [gtmData],
            },
          });
        } else {
          gtmProducts.forEach(product => {
            if (Number(product.id) === sku) {
              window.dataLayer.push({
                event: 'wishlist',
                action: 'remove',
                pageType: window.gtm.pageType,
                ecommerce: {
                  products: [product],
                },
              });
            }
          });
        }

        await addOrDeleteWishlist('removeItem', sku, variantId).then(() => {
          delete window.Jbhifi.wishlistItems[sku];
        });
      }
    },
    isFull: () => {
      return window.Jbhifi.customerWishlist.length > 99;
    },
  };
}
